var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    _vm._b(
      {
        attrs: { id: "whatsapp-button" },
        on: {
          click: function ($event) {
            $event.stopPropagation()
            return _vm.onClick.apply(null, arguments)
          },
        },
      },
      "button",
      _vm.buttonProps,
      false
    ),
    [
      _c(
        "div",
        { staticClass: "d-flex align-items-center" },
        [
          _c("svg-icon-whatsapp", {
            class: !_vm.hideText ? "mr-1 mr-sm-2" : null,
            attrs: {
              outlined: !_vm.hideText,
              size: _vm.isDetailView ? 18 : 24,
            },
          }),
          _vm._v(" "),
          !_vm.hideText ? _c("span", [_vm._v(_vm._s(_vm.title))]) : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }